import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import {
  CategoryBaseInfo,
  GetCategoryAdsCounterResponse,
} from '@/api/types/categories.types';
import { useParseQuery } from '@/hooks/useParseQuery/useParseQuery';
import {
  CATEGORY_SLUG_INDEX,
  SUBCATEGORY_SLUG_INDEX,
} from '@/hooks/useCurrentCategory/useCurrentCategory.constants';
import { ROOT_CATEGORY_SLUG } from '@/constants/common';
import { GET_CATEGORY_ADS_COUNTER } from '@/api/queries/categories.queries';

export function useAdsCounter(currentCategory?: CategoryBaseInfo | null): {
  adsAmount: number | undefined;
  loading?: boolean;
} {
  const router = useRouter();
  const { keywords, price, regionId, propertyOptions, userLegacyId, isShop } =
    useParseQuery();

  const categorySlug = router.query.slug?.[CATEGORY_SLUG_INDEX];
  const subcategorySlug = router.query.slug?.[SUBCATEGORY_SLUG_INDEX];
  const path = [categorySlug, subcategorySlug].reduce(
    (acc, slug) => (slug ? `${acc}/${slug}` : acc),
    ROOT_CATEGORY_SLUG
  );
  const filters = {
    price,
    regionId,
    propertyOptions,
    userLegacyId,
    isShop,
  };
  const currentCategoryId = currentCategory?.path.includes('/')
    ? currentCategory?.id
    : '';
  const isBrowser = typeof window !== 'undefined';

  const { data: adsCounterData, loading } =
    useQuery<GetCategoryAdsCounterResponse>(GET_CATEGORY_ADS_COUNTER, {
      variables: {
        path,
        keywords,
        filters: { ...filters, categoryId: currentCategoryId },
      },
      skip: !currentCategory || !isBrowser,
      notifyOnNetworkStatusChange: true,
    });

  const adsAmount = adsCounterData?.category?.count;

  return {
    adsAmount,
    loading: !isBrowser || loading,
  };
}
